/*
 * @Author: shikexin shikexin0116@163.com
 * @Date: 2022-09-28 16:10:02
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-09-29 17:23:50
 * @FilePath: /www.geekbang.org/src/components/layout/header/menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import config from '@/config'

const menuList = [
  {
    name: '极客时间个人版',
    link: config.timeServer
  },
  {
    name: '极客时间企业版',
    link: config.bServer
  },
  {
    name: 'InfoQ 极客传媒',
    link: config.infoq,
    submenu: [
      {
        name: 'InfoQ 媒体社区',
        link: config.infoq
      },
      {
        name: 'InfoQ 技术大会',
        link: config.infoqMeeting
      },
      {
        name: 'InfoQ 企业服务',
        disabled: true,
        link: ''
      }
    ]
  },
  {
    name: '技术大会',
    link: config.infoqMeeting
  },
  {
    name: 'TGO 鲲鹏会',
    link: config.tgo
  },
  {
    name: '双数研究院',
    link: `${config.geekbangServer}/number`
  },
  {
    name: '关于我们',
    link: `${config.geekbangServer}/aboutus`,
    submenu: [
      {
        name: '公司简介',
        link: `${config.geekbangServer}/aboutus?anchor=profile`,
        replace: true
      },
      {
        name: '核心价值观',
        link: `${config.geekbangServer}/aboutus?anchor=values`,
        replace: true
      },
      {
        name: '发展历程',
        link: `${config.geekbangServer}/aboutus?anchor=history`,
        replace: true
      },
      {
        name: '资质荣誉',
        link: `${config.geekbangServer}/aboutus?anchor=honor`,
        replace: true
      },
      {
        name: '我们的伙伴',
        link: `${config.geekbangServer}/aboutus?anchor=partner`,
        replace: true
      },
      {
        name: '新闻动态',
        link: `${config.geekbangServer}/news`
      }
    ]
  }
]

export {
  menuList
}
